import * as yup from 'yup';
import moment from 'moment';
import { isNaN } from 'lodash';
import StorageService from '../../services/StorageService';

const Storage = new StorageService();
export const homeSchema = yup.object({
  product: yup.string().required(),
  source: yup.string().required(),
  name: yup
    .string()
    .nullable()
    .when('gender', ([gender], schema) => (gender !== 'G'
      ? schema
        .required('Il campo è obbligatorio. Inserisci il nome!')
        .matches(
          /^[a-zA-Z ]+$/,
          'Non sono ammessi numeri o caratteri speciali!',
        )
      : schema)),
  surname: yup
    .string()
    .nullable()
    .when('gender', ([gender], schema) => (gender !== 'G'
      ? schema
        .required('Il campo è obbligatorio. Inserisci il cognome!')
        .matches(
          /^[a-zA-Z ]+$/,
          'Non sono ammessi numeri o caratteri speciali!',
        )
      : schema)),
  gender: yup.string().required('Il campo è obbligatorio. Seleziona genere!'),
  date_of_birth: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona data di nascita!')
    .test('valid-date', 'La data di nascita non è valida. L\'età minima è 18 anni', (value) => {
      if (!value) return true;
      const date = moment(value, 'YYYY-MM-DD', true);
      const year = date.year();
      const currentYear = new Date().getFullYear();

      if (year > currentYear - 18) {
        return false;
      }
      return date.isValid();
    }),
  commune_of_birth_code: yup
    .string()
    .nullable()
    .when(['gender', 'born_abroad'], ([gender, born_abroad], schema) => (gender !== 'G'
      ? born_abroad === false
        ? schema.required(
          'Il campo è obbligatorio. Inserisci luogo di nascita del contraente!',
        )
        : schema
      : schema)),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non e corretto'),
  email: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci Email!')
    .email('Deve essere un email valido! Rimouvi spazi vuoti!')
    .test('brokerEmail', 'Non puoi impostare la tua email', (value) => value !== Storage.getUser().email),
  residence_commune_code: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona provincia di residenza!'),
  province_of_birth_code: yup
    .string()
    .nullable()
    .when(['gender', 'born_abroad'], ([gender, born_abroad], schema) => (gender !== 'G'
      ? born_abroad === false
        ? schema.required(
          'Il campo è obbligatorio. Inserisci luogo di nascita del contraente!',
        )
        : schema
      : schema)),
  born_abroad: yup
    .boolean()
    .required('Il campo è obbligatorio. Seleziona se nato al estero!'),
  country_of_birth_code: yup
    .string()
    .nullable()
    .when('gender', ([gender], schema) => (gender !== 'G'
      ? schema.required(
        'Il campo è obbligatorio. Seleziona il stato estero!',
      )
      : schema)),
  address: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci indirizzo!'),
  house_number: yup.string().required('Il campo è obbligatorio.').matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
  postal_code: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci codice postale!')
    .matches(/^[0-9]{5}$/, 'Il codice postale non e coretto'),
  fiscal_code: yup.string().nullable(),
  residence_province_code: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona provincia di residenza!'),
  existing_customer: yup.boolean(),
  active_customer_id: yup.number().nullable(),
  policy_effective_date: yup
    .date()
    .typeError('Il campo è obbligatorio. Seleziona data decorrenza!')
    .required('Il campo è obbligatorio. Seleziona data decorrenza!')
    .min(
      new Date(moment().subtract(1, 'day').format('YYYY-MM-DD')),
      'La data è nel passato',
    )
    .max(
      new Date(moment().add(30, 'day').format('YYYY-MM-DD')),
      'La data è nel futuro',
    ),
  privacies: yup.array(yup.number()),
  owner_typology: yup.string().required('Il campo è obbligatorio. Seleziona Tipologia Propietario!'),
  square_meters: yup.string().required("Il campo è obbligatorio. Imposta la superficie dell'abitazione!").matches(/^\d*\.?\d+$/, 'Inserisci solo numeri o decimali.'),
  house_type: yup.string().required("Il campo è obbligatorio. Imposta tipologia dell'abitazione!"),
  business_name: yup
    .string()
    .nullable()
    .when('gender', {
      is: 'G',
      then: () => yup
        .string()
        .required("Il campo è obbligatorio. Inserisci il nome dell'azienda!"),
    }),
  vat_number: yup
    .string()
    .nullable()
    .when('gender', {
      is: 'G',
      then: () => yup
        .string()
        .max(11, 'La partiva iva non puo essere piu di 11 numeri!')
        .matches(/^[0-9]*$/, 'Solo numeri sono ammessi!')
        .required('Il campo è obbligatorio. Inserisci la tua partita iva!'),
    }),
  company_type: yup
    .string()
    .nullable()
    .when('gender', {
      is: 'G',
      then: () => yup.string().required('Il campo è obbligatorio'),
    }),
  housing_type: yup.string().required('Il campo è obbligatorio. Seleziona Tipologia abitativa!'),
  presence_of_condominium_policy: yup.string().when('house_type', {
    is: '2',
    then: (s) => s.required('Il campo è obbligatorio. Seleziona Presenza di polizza condominiale!'),
  }),
  interested_in_building_fire_coverage: yup.string().when(
    'residential_use_types',
    {
      is: (val) => ['145', '146'].includes(val),
      then: (schema) => schema.nullable(), // not required
      otherwise: (schema) => schema.required('Il campo è obbligatorio.'),
    },
  ),

  // interested_in_contents_fire_coverage: yup.string().when(
  //   'residential_use_types',
  //   {
  //     is: (val) => val === 144,
  //     then: (schema) => schema.nullable(), // not required
  //     otherwise: (schema) => schema.required('Il campo è obbligatorio.'),
  //   },
  // ),
  interested_in_contents_fire_coverage: yup.string().required('Il campo è obbligatorio.'),
  // interested_in_building_fire_coverage: yup.string().required('Il campo è obbligatorio.'),
  building_value: yup
    .string()
    .nullable()
    .when('interested_in_building_fire_coverage', {
      is: (val) => val && val !== '0' && val !== 0,
      then: (schema) => schema
        .required('Il campo è obbligatorio.')
        .test('is-number', 'Il valore deve essere un numero valido.', (value) => !isNaN(Number(value)))
        .test('min', 'Il valore minimo consentito è 50,000.', (value) => {
          if (!value) return false;
          return Number(value) >= 50000;
        })
        .test('max', 'Il valore massimo consentito è 500,000€.', (value) => {
          if (!value) return false;
          return Number(value) <= 500000;
        }),
      otherwise: (schema) => schema.nullable(),
    }),

  insured_amount_contents_fire: yup
    .string()
    .nullable()
    .when('interested_in_contents_fire_coverage', {
      is: (val) => val && val !== '0',
      then: (schema) => schema
        .required('Il campo è obbligatorio.')
        .test('is-number', 'Il valore deve essere un numero valido.', (value) => !isNaN(Number(value)))
        .test('min', 'Il valore minimo consentito è 5,000.', (value) => {
          if (!value) return false;
          return Number(value) >= 5000;
        }),
      otherwise: (schema) => schema.nullable(),
    }),
  residential_use_types: yup.string().required('Il campo è obbligatorio. Seleziona Uso abitazione!'),
  floor_level: yup.string().when('house_type', {
    is: '2',
    then: (s) => s.required('Il campo è obbligatorio.'),
    otherwise: (s) => s.nullable(),
  }),
  construction_feature_types: yup.string().required('Il campo è obbligatorio. Seleziona Caratteristiche costruttive!'),
  construction_year: yup.string().required('Il campo è obbligatorio. Seleziona Anno di costruzione!'),
  current_address: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci indirizzo!'),
  current_house_number: yup.string().required('Il campo è obbligatorio.').matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
  current_postal_code: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci codice postale!')
    .matches(/^[0-9]{5}$/, 'Il codice postale non e coretto'),
  house_province_code: yup.string().required('Il campo è obbligatorio. Seleziona Provincia Abitazione!'),
  house_commune_code: yup.string().required('Il campo è obbligatorio. Seleziona Provincia Abitazione!'),
  insurance_formula: yup.string().required('Il campo è obbligatorio. Seleziona Formula assicurativa!'),
  location_guarantees: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          selected: yup.boolean(),
          cod_garanzie: yup.array(),
          // Stored guarantees without parameters persist as [] (PHP empty array);
          // coerce to {} so yup.object() doesn't typeError on the array shape.
          parameters: yup
            .object()
            .transform((value) => (Array.isArray(value) ? {} : value)),
          building_value: yup.string(),
          parametersConfig: yup.array(),
        })
        .test('validate-selected-guarantees', function (value) {
          if (!value?.selected) return true;

          const isTerremoto = value.cod_garanzie?.includes('TF');

          if (isTerremoto && !value.building_value) {
            return this.createError({
              path: `${this.path}.building_value`,
              message:
                'Il valore fabbricato è obbligatorio per TERREMOTO DANNI AI LOCALI',
            });
          }

          if (value.parametersConfig?.length > 0) {
            const missingParam = value.parametersConfig.find(
              (param) => !value.parameters?.[param.cod_param],
            );

            if (missingParam) {
              return this.createError({
                path: `${this.path}.parameters.${missingParam.cod_param}`,
                message: `Il campo ${missingParam.desc_parameter} è obbligatorio`,
              });
            }
          }

          return true;
        }),
    )
    .when('insurance_formula', {
      is: (val) => val !== '112',
      then: (schema) => schema.test(
        'at-least-one-selected',
        'Devi selezionare almeno una garanzia',
        (value) => {
          if (!value || value.length === 0) return false;
          return value.some((g) => g.selected === true);
        },
      ),
      otherwise: (schema) => schema.min(0),
    }),
  insured_guarantees: yup.array().when('insurance_formula', {
    is: (val) => val !== '113',
    then: (schema) => schema
      .min(1, 'Devi selezionare almeno una garanzia assicurato.')
      .required('Devi selezionare almeno una garanzia assicurato.'),
    otherwise: (schema) => schema.min(0),
  }),
});

export const answersHomeFieldsBySteps = [
  [
    'insurance_formula',
    'gender',
    'business_name',
    'date_of_birth',
    'vat_number',
    'company_type',
    'commune_of_birth_code',
    'province_of_birth_code',
    'born_abroad',
    'residence_commune_code',
    'residence_province_code',
    'postal_code',
    'house_number',
    'address',
    'name',
    'surname',
    'email',
    'phone',
    'policy_effective_date',
    'fiscal_code',
    'country_of_birth_code',
  ],
  [
    'insured_guarantees',
  ],
  [
    'house_type',
    'housing_type',
    'floor_level',
    'presence_of_condominium_policy',
    'residential_use_types',
    'construction_feature_types',
    'construction_year',
    'interested_in_building_fire_coverage',
    'interested_in_contents_fire_coverage',
    'building_value',
    'insured_amount_contents_fire',
    'owner_typology',
    'square_meters',
    'current_address',
    'current_house_number',
    'current_postal_code',
    'house_province_code',
    'house_commune_code',
  ],
  [
    'location_guarantees',
  ],

];
